(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'kotlinx-serialization-kotlinx-serialization-core-jsLegacy'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('kotlinx-serialization-kotlinx-serialization-core-jsLegacy'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-common-types-jsLegacy'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'kvision-kvision-common-types-jsLegacy'.");
    }if (typeof this['kotlinx-serialization-kotlinx-serialization-core-jsLegacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-common-types-jsLegacy'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core-jsLegacy' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core-jsLegacy' is loaded prior to 'kvision-kvision-common-types-jsLegacy'.");
    }root['kvision-kvision-common-types-jsLegacy'] = factory(typeof this['kvision-kvision-common-types-jsLegacy'] === 'undefined' ? {} : this['kvision-kvision-common-types-jsLegacy'], kotlin, this['kotlinx-serialization-kotlinx-serialization-core-jsLegacy']);
  }
}(this, function (_, Kotlin, $module$kotlinx_serialization_kotlinx_serialization_core_jsLegacy) {
  'use strict';
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var PluginGeneratedSerialDescriptor = $module$kotlinx_serialization_kotlinx_serialization_core_jsLegacy.kotlinx.serialization.internal.PluginGeneratedSerialDescriptor;
  var internal = $module$kotlinx_serialization_kotlinx_serialization_core_jsLegacy.kotlinx.serialization.internal;
  var equals = Kotlin.equals;
  var GeneratedSerializer = $module$kotlinx_serialization_kotlinx_serialization_core_jsLegacy.kotlinx.serialization.internal.GeneratedSerializer;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var KFile$Companion_instance = null;
  function KFile$$serializer() {
    this.descriptor_8timtw$_0 = new PluginGeneratedSerialDescriptor('io.kvision.types.KFile', this, 3);
    this.descriptor.addElement_ivxn3r$('name', false);
    this.descriptor.addElement_ivxn3r$('size', false);
    this.descriptor.addElement_ivxn3r$('content', true);
    KFile$$serializer_instance = this;
  }
  var KFile$$serializer_instance = null;
  var KV_DEFAULT_DATE_FORMAT;
  KFile$$serializer.prototype.typeParametersSerializers = GeneratedSerializer.prototype.typeParametersSerializers;
  KV_DEFAULT_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
  return _;
}));

//# sourceMappingURL=kvision-kvision-common-types-jsLegacy.js.map
